import pilot from "./pilot.json";

/** The workspaces that see the Test section. The demo workspace is included so the demo view and review builds show it. */
export const GROWTH_PILOT_CLIENT_SLUGS = Object.freeze([...pilot.clientSlugs]);

export const growthEnabled = (clientSlug) => Boolean(clientSlug) && GROWTH_PILOT_CLIENT_SLUGS.includes(clientSlug);
